const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index'),
    meta: {
      title: '首页',
      keepAlive: false
    }
  },
  {
    path: '/protected',
    component: () => import('@/views/protected'),
    meta: {
    }
  },
  {
    path: '/noPermission',
    component: () => import('@/views/noPermission'),
    meta: {
    }
  },
  {
    path: '/user/login',
    component: () => import('@/views/user/login'),
    meta: {
    }
  },
  {
    path: '/user/register',
    component: () => import('@/views/user/register'),
    meta: {
    }
  },
  {
    path: '/filePreview',
    name: 'index',
    component: () => import('@/views/FilePreview'),
    meta: {
      title: '文件预览',
      keepAlive: false
    }
  },
  {
    path: '/tenderDoc',
    name: 'tenderDoc',
    redirect: '/tenderDoc/home',
    component: () => import('@/layout/base/index'),
    children: [
      // 招标首页
      {
        path: '/tenderDoc/home',
        component: () => import('@/views/tenderDoc/home/index'),
        meta: {
          title: '标书管理',
          keepAlive: true,
          requiresLoginWorkWechat: true
        }
      },
      {
        path: '/tenderDoc/add',
        component: () => import('@/views/tenderDoc/add/index'),
        meta: {
          title: '创建标书',
          keepAlive: true
        }
      },
      {
        path: '/tenderDoc/detail',
        component: () => import('@/views/tenderDoc/detail/index'),
        meta: {
          title: '详情与开标',
          keepAlive: true
        }
      },
      {
        path: '/tenderDoc/createCopy',
        component: () => import('@/views/tenderDoc/createCopy/index'),
        meta: {
          title: '创建副本',
          keepAlive: true
        }
      },
      // 投标首页
      {
        path: '/tendering/home',
        component: () => import('@/views/tendering/home/index'),
        meta: {
          title: '首页',
          keepAlive: true
        }
      },
      {
        path: '/tendering/tendering',
        component: () => import('@/views/tendering/tendering/index'),
        meta: {
          title: '填写投标信息',
          keepAlive: true,
          requiresAuth: true,
        }
      },
      {
        path: '/tendering/detail',
        component: () => import('@/views/tendering/detail/index'),
        meta: {
          title: '标书详情',
          keepAlive: true,
          requiresAuth: true
        }
      },
      // 权限配置首页
      {
        path: '/permissionConfig/home',
        component: () => import('@/views/permissionConfig/home/index'),
        meta: {
          title: '权限配置',
          keepAlive: true
        }
      },
      // 黑名单配置首页
      {
        path: '/blacklistConfig/home',
        component: () => import('@/views/blacklistConfig/home/index'),
        meta: {
          title: '黑名单配置',
          keepAlive: true
        }
      },
      // 客户管理
      {
        path: '/user/home',
        component: () => import('@/views/user/index'),
        meta: {
          title: '客户管理',
          keepAlive: true
        }
      },
    ]
  },
  // 林业竞拍首页
  {
    path: '/auctionItem/default-login',
    component: () => import('@/views/auctionItem/default-login'),
    meta: {
    }
  },
  {
    path: '/auctionItem/login',
    component: () => import('@/views/auctionItem/login'),
    meta: {
    }
  },
  {
    path: '/auctionItem/register',
    component: () => import('@/views/auctionItem/register'),
    meta: {
    }
  },
  {
    path: '/auctionItem/sysLogin',
    component: () => import('@/views/auctionItem/sysLogin'),
    meta: {
    }
  },
  {
    path: '/auctionItem/protected',
    component: () => import('@/views/auctionItem/protected'),
    meta: {
    }
  },
  {
    path: '/auctionItem',
    name: 'auctionItem',
    redirect: '/auctionItem/home',
    component: () => import('@/layout/base/index'),
    children: [
      {
        path: '/auctionItem/home',
        component: () => import('@/views/auctionItem/home/index'),
        meta: {
          title: '标书管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      {
        path: '/auctionItem/add',
        component: () => import('@/views/auctionItem/add/index'),
        meta: {
          title: '创建标书',
          keepAlive: true
        }
      },
      {
        path: '/auctionItem/detail',
        component: () => import('@/views/auctionItem/detail/index'),
        meta: {
          title: '详情与开标',
          keepAlive: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      {
        path: '/auctionItem/createCopy',
        component: () => import('@/views/auctionItem/createCopy/index'),
        meta: {
          title: '创建副本',
          keepAlive: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      {
        path: '/auctionItem/history',
        component: () => import('@/views/auctionItem/history/index'),
        meta: {
          title: '关联标的',
          keepAlive: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      {
        path: '/auctionItem/user/home',
        component: () => import('@/views/auctionItem/user/index'),
        meta: {
          title: '用户管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      {
        path: '/auctionItem/bidUser/home',
        component: () => import('@/views/auctionItem/bidUser/index'),
        meta: {
          title: '客户管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/auctionItem/sysLogin' 
        }
      },
      // 林业竞拍-投标首页
      {
        path: '/auctionItem/tendering/home',
        component: () => import('@/views/auctionItem/tendering/home/index'),
        meta: {
          title: '首页',
          keepAlive: true,
          loginPage: '/auctionItem/login' 
        }
      },
      {
        path: '/auctionItem/tendering/detail',
        component: () => import('@/views/auctionItem/tendering/detail/index'),
        meta: {
          title: '标书详情',
          keepAlive: true,
          auctionItemRequiresAuth: true,
          loginPage: '/auctionItem/login' 
        }
      },
    ]
  },

  // 物流招标
  {
    path: '/logisticsTender/sysLogin',
    component: () => import('@/views/logisticsTender/sysLogin'),
    meta: {
    }
  },
  {
    path: '/logisticsTender/register',
    component: () => import('@/views/logisticsTender/register'),
    meta: {
    }
  },
  {
    path: '/logisticsTender/login',
    component: () => import('@/views/logisticsTender/login'),
    meta: {
    }
  },
  {
    path: '/logisticsTender/protected',
    component: () => import('@/views/logisticsTender/protected'),
    meta: {
    }
  },
  {
    path: '/logisticsTender',
    name: 'logisticsTender',
    redirect: '/logisticsTender/home',
    component: () => import('@/layout/base/index'),
    children: [
      {
        path: '/logisticsTender/home',
        component: () => import('@/views/logisticsTender/home/index'),
        meta: {
          title: '标书管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      },
      {
        path: '/logisticsTender/add',
        component: () => import('@/views/logisticsTender/add/index'),
        meta: {
          title: '创建标书',
          keepAlive: true
        }
      },
      {
        path: '/logisticsTender/detail',
        component: () => import('@/views/logisticsTender/detail/index'),
        meta: {
          title: '详情与开标',
          keepAlive: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      },
      {
        path: '/logisticsTender/createCopy',
        component: () => import('@/views/logisticsTender/createCopy/index'),
        meta: {
          title: '创建副本',
          keepAlive: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      },
      {
        path: '/logisticsTender/factoryLine/home',
        component: () => import('@/views/logisticsTender/factoryLine/index'),
        meta: {
          title: '工厂线路配置',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      },
      {
        path: '/logisticsTender/user/home',
        component: () => import('@/views/logisticsTender/user/index'),
        meta: {
          title: '系统用户管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      }
      ,
      {
        path: '/logisticsTender/bidEnterprise/home',
        component: () => import('@/views/logisticsTender/bidEnterprise/index'),
        meta: {
          title: '企业管理',
          keepAlive: true,
          requiresLoginWorkWechat: true,
          loginPage: '/logisticsTender/sysLogin' 
        }
      },
      // 评分标准配置首页
      {
        path: '/logisticsTender/gradingCriteria/home',
        component: () => import('@/views/logisticsTender/gradingCriteria/index'),
        meta: {
          title: '评分标准配置',
          keepAlive: true
        }
      },
      // 系统参数配置首页
      {
        path: '/sysConfig/home',
        component: () => import('@/views/sysConfig/home/index'),
        meta: {
          title: '参数配置',
          keepAlive: true
        }
      },
      // 工厂系数配置首页
      {
        path: '/logisticsTender/conversionFraction/home',
        component: () => import('@/views/logisticsTender/conversionFraction/index'),
        meta: {
          title: '工厂信息配置',
          keepAlive: true
        }
      },// 工厂利率配置首页
      {
        path: '/logisticsTender/interestRate/home',
        component: () => import('@/views/logisticsTender/interestRate/index'),
        meta: {
          title: '工厂利率配置',
          keepAlive: true
        }
      },
      // 物流招标-投标首页
      {
        path: '/logisticsTender/tendering/home',
        component: () => import('@/views/logisticsTender/tendering/home/index'),
        meta: {
          title: '首页',
          keepAlive: true,
          loginPage: '/logisticsTender/login' 
        }
      },
      {
        path: '/logisticsTender/tendering/detail',
        component: () => import('@/views/logisticsTender/tendering/detail/index'),
        meta: {
          title: '标书详情',
          keepAlive: true,
          logisticsRequiresAuth: true,
          loginPage: '/logisticsTender/login' 
        }
      },
    ]
  }
]
export default routes
